import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { Container, Typography, Grid, Paper } from "@mui/material";

// Token distribution data
const pieData = [
  { name: "Paper Rewards", value: 90 },
  { name: "Liquidity", value: 5 },
  { name: "Development Fund", value: 3 },
  { name: "Community", value: 1 },
  { name: "Team", value: 1 }
];

// オリジナルに近いシアン系のカラーパレット
const COLORS = ["#00FFFF", "#00BFBF", "#009F9F", "#007F7F", "#005F5F"];

// Supply growth data
const barData = [
  { year: "2025", supply: 10 },
  { year: "2026", supply: 11.5 },
  { year: "2027", supply: 13 },
  { year: "2028", supply: 15 },
];

const TokenomicsChart = () => {
  return (
    <Container
      maxWidth="lg"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #001F1F 0%, #003F3F 100%)",
        padding: "40px",
        borderRadius: "20px",
        color: "white",
        border: "1px solid rgba(0, 255, 255, 0.3)",
        boxShadow: "0px 0px 25px rgba(0, 255, 255, 0.5)",
      }}
    >
      <Typography
        variant="h4"
        gutterBottom
        style={{
          textAlign: "center",
          fontWeight: "bold",
          marginBottom: "20px",
        }}
      >
        EMCII Tokenomics <br /> (Finally 15B $EMCII will be supplied)
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {/* Pie Chart (Token Distribution) */}
        <Grid item xs={12} sm={6}>
          <Paper
            style={{
              padding: "20px",
              backgroundColor: "#002F2F",
              borderRadius: "15px",
              boxShadow: "0 0 20px rgba(0, 255, 255, 0.2)",
            }}
          >
            <Typography
              variant="h5"
              style={{ textAlign: "center", marginBottom: "10px" }}
            >
              Token Distribution
            </Typography>
            <ResponsiveContainer width="100%" height={350}>
              <PieChart>
                <Pie
                  data={pieData}
                  cx="50%"
                  cy="50%"
                  outerRadius={100}
                  dataKey="value"
                  // label属性を設定しないことで、円グラフ周りにリーダーライン付きのラベルは表示されません
                >
                  {pieData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(value, name) => [`${value}%`, name]} // Tooltip に「%」を追加
                  contentStyle={{
                    backgroundColor: "#002F2F",
                    borderRadius: "10px",
                    color: "white",
                  }}
                  itemStyle={{ color: "white" }}
                />
                <Legend 
   verticalAlign="bottom" 
   align="left"
   formatter={(value, entry, index) => `${value} (${pieData[index].value}%)`}
   wrapperStyle={{ color: "white" }}
/>

              </PieChart>
            </ResponsiveContainer>
          </Paper>
        </Grid>

        {/* Bar Chart (Supply Growth) */}
        <Grid item xs={12} sm={6}>
          <Paper
            style={{
              padding: "20px",
              backgroundColor: "#002F2F",
              borderRadius: "15px",
              boxShadow: "0 0 20px rgba(0, 255, 255, 0.2)",
            }}
          >
            <Typography
              variant="h5"
              style={{ textAlign: "center", marginBottom: "10px" }}
            >
              Supply Growth (2025 - 2028)
            </Typography>
            <ResponsiveContainer width="100%" height={350}>
              <BarChart data={barData}>
                <CartesianGrid
                  strokeDasharray="3 3"
                  stroke="rgba(255,255,255,0.2)"
                />
                <XAxis dataKey="year" stroke="white" />
                <YAxis
                  stroke="white"
                  domain={[0, 16]}
                  tickFormatter={(value) => `${value}B`} // Y軸に「B」を付与
                />
                <Tooltip
                  formatter={(value, name) => [`${value}B`, name]} // Tooltip に「B」を付与
                  contentStyle={{
                    backgroundColor: "#002F2F",
                    borderRadius: "10px",
                    color: "white",
                  }}
                  itemStyle={{ color: "white" }}
                />
                <Legend wrapperStyle={{ color: "white" }} />
                <Bar
                  dataKey="supply"
                  fill="url(#colorSupply)"
                  barSize={30}
                  radius={[10, 10, 0, 0]}
                />
                <defs>
                  <linearGradient id="colorSupply" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#00FFFF" stopOpacity={0.9} />
                    <stop offset="95%" stopColor="#007F7F" stopOpacity={0.9} />
                  </linearGradient>
                </defs>
              </BarChart>
            </ResponsiveContainer>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default TokenomicsChart;

